import Api from './rest/SupplierApi';

export default new Api();
